module.exports = __webpack_public_path__ + "assets/img/returnBtn-2b42cf1a.png";